import React, { useEffect } from "react";
import { Modal, Form, Select, Button } from "antd";
import { useGlobalContext } from "../../context/GlobalContext";
import useGet from "../common/useGet";
import { API_MERCHANTS_USERS, API_REQUEST_PUBLIC_KEY } from "../../utils/apis";
import useSet from "../common/useSet";
import { useToasts } from "../common/useToasts";

const IframeKeyGeneration: React.FC = () => {
  const { data: globalData, updateData } = useGlobalContext();
  const { openIframeKeyGeneration } = globalData || {};
  const [form] = Form.useForm();
  const { data: merchantsData, loadData, loading: merchantsLoading } = useGet();
  const { uploadData, submitting, error, success } = useSet();

  useEffect(() => {
    if (openIframeKeyGeneration) {
      loadData({ api: API_MERCHANTS_USERS });
    }
  }, [openIframeKeyGeneration]);

  const handleClose = () => {
    updateData({ openIframeKeyGeneration: false });
    form.resetFields();
  };

  const handleSubmit = (values: any) => {
    uploadData({
      api: API_REQUEST_PUBLIC_KEY,
      params: {
        user: values.merchantId,
      },
    });
  };

  useToasts({
    success,
    error,
    submitting: submitting,
    // redirect: "reload",
    successMessage: "Iframe key generated successfully",
    callback: () => {
      form.resetFields();
      updateData({ openIframeKeyGeneration: false });
    },
  });

  return (
    <Modal
      open={!!openIframeKeyGeneration}
      onCancel={handleClose}
      title="Generate Iframe Key"
      footer={null}
      centered
      width={500}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        autoComplete="off"
      >
        <Form.Item
          label="Merchant"
          name="merchantId"
          rules={[{ required: true, message: "Please select a merchant" }]}
        >
          <Select
            placeholder="Select merchant"
            size="large"
            loading={merchantsLoading}
            showSearch
            filterOption={(input, option) =>
              String(option?.label ?? "")
                .toLowerCase()
                .includes(input.toLowerCase())
            }
            options={merchantsData?.map((merchant: any) => ({
              value: merchant?.id,
              label: merchant?.name,
            }))}
          />
        </Form.Item>

        <Form.Item style={{ marginBottom: 0, marginTop: 24 }}>
          <div style={{ display: "flex", gap: 12, justifyContent: "flex-end" }}>
            <Button onClick={handleClose} size="large">
              Cancel
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              loading={submitting}
              size="large"
            >
              Generate Key
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default IframeKeyGeneration;
